import { useCallback, useEffect, useRef, useState } from 'react';

const DURACAO_CONFIRMACAO_MS = 1800;

/**
 * Copia o texto da resposta para a area de transferencia.
 *
 * navigator.clipboard so existe em contexto seguro (https ou localhost): em
 * HTTP puro ele e undefined. A falha aqui e silenciosa de proposito -- copiar e
 * conveniencia, e derrubar a bolha da conversa por causa dela seria pior do que
 * o botao simplesmente nao responder.
 */
const useMensagemAssistenteHook = ({ conteudo }) => {
  const [copiado, setCopiado] = useState(false);
  const temporizadorRef = useRef(null);

  // Sem isto, copiar e trocar de conversa antes do timeout dispararia um
  // setState em componente desmontado.
  useEffect(() => () => clearTimeout(temporizadorRef.current), []);

  const copiar = useCallback(() => {
    if (!navigator.clipboard?.writeText) {
      return;
    }

    navigator.clipboard
      .writeText(conteudo ?? '')
      .then(() => {
        setCopiado(true);
        clearTimeout(temporizadorRef.current);
        temporizadorRef.current = setTimeout(() => setCopiado(false), DURACAO_CONFIRMACAO_MS);
      })
      .catch(() => setCopiado(false));
  }, [conteudo]);

  return { copiar, copiado };
};

export default useMensagemAssistenteHook;
